import React from "react";
import { styled } from "@mui/system";
import PropTypes from "prop-types";
import Box from "../Box";

type Props = {
  children?: React.ReactNode;
  withMargin?: Boolean;
};

export const VaporPageSection = styled(
  (props: Props) => (
    <Box
      sx={{
        maxWidth: " 100%",
        display: "flex",
        padding: props.withMargin ? "24px" : 0,
      }}
    >
      {props.children}
    </Box>
  ),
  {
    name: "VaporPageSection",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({}));
